var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedIcp0)",
    fillRule: "evenodd",
    d: "m12 13.252l.022-.026c1.251 1.217 3.055 2.631 4.62 2.631A3.89 3.89 0 0 0 20.572 12c0-2.13-1.758-3.857-3.93-3.857c-1.663 0-3.3 1.234-4.642 2.606zm4.586 1.045c1.337 0 2.421-1.028 2.421-2.297c0-1.268-1.084-2.297-2.425-2.297c-1.342 0-2.649 1.243-3.566 2.297c.608.686 2.228 2.297 3.566 2.297z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedIcp1)",
    fillRule: "evenodd",
    d: "m12.052 13.303l-.086-.086c-1.213 1.205-3 2.64-4.607 2.64A3.89 3.89 0 0 1 3.429 12c0-2.13 1.757-3.857 3.93-3.857c1.688 0 3.257 1.333 4.577 2.756l.116-.12zm-4.638.994C6.073 14.297 4.99 13.27 4.99 12c0-1.268 1.084-2.297 2.425-2.297c1.342 0 2.649 1.243 3.566 2.297c-.608.686-2.228 2.297-3.566 2.297",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46ABE3",
    d: "m10.817 11.859l.103.09l1.05 1.337c1.234 1.153 3.034 2.571 4.672 2.571a3.91 3.91 0 0 0 3.857-3.111c-.335.604-1.5 1.551-3.583 1.53a3 3 0 0 1-.334.021c-1.342 0-2.958-1.611-3.566-2.297l.013-.017l-1.265-1.521l-1.264-1.2C9.49 8.49 8.443 8.006 7.294 8.006c-1.941 0-3.501 1.543-3.814 3.386c.866-1.569 2.73-2.075 4.367-1.642c1.072.184 2.002 1.037 2.97 2.109"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedIcp0",
    x1: 21.446,
    x2: 2.614,
    y1: 11.565,
    y2: 11.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5E12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedIcp1",
    x1: 5.039,
    x2: 20.955,
    y1: 11.639,
    y2: 11.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA1980"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/icp.2c2b91da1e70ad6f3812de3a508d5973.svg";
export { ForwardRef as ReactComponent };